import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=8966f7cc"
import script from "./layer.vue?vue&type=script&lang=js"
export * from "./layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports